import { SupabaseService } from "../../../server/supabase/base-supabase-service";

import type { UUID } from "../../../utils/uuid";

export class SupabaseTagsService extends SupabaseService<"tag"> {
  table = "tag" as const;

  async deleteTag(tag_id_: UUID) {
    return this.log_errors(this.client.rpc("delete_tag", { tag_id_ }));
  }
}
